import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ToastStackProvider } from "./context/ToastStackContext";
import ErrorBoundary from "./components/ErrorBoundary";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// Imported for its side effect: it has to be listening for the browser's
// install event from the very start, before any page that shows an Install
// button has mounted.
import "./utils/installPrompt";

// Every address the site answers on keeps its own separate login (browser
// storage is per address), so more than one of them in circulation makes
// people look logged out whenever they land on a different one. Send the
// others to the one real address, gatheryou.in: the raw *.workers.dev link the
// site was first shared at (whose popups also title themselves with that
// hosting address), and the www. version.
const { hostname } = window.location;
if (hostname.endsWith(".workers.dev") || hostname === "www.gatheryou.in") {
  const { pathname, search, hash } = window.location;
  window.location.replace(`https://gatheryou.in${pathname}${search}${hash}`);
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <BrowserRouter>
      <React.StrictMode>
        <ErrorBoundary>
          <ThemeProvider>
            <LanguageProvider>
              <ToastStackProvider>
                <App />
              </ToastStackProvider>
            </LanguageProvider>
          </ThemeProvider>
        </ErrorBoundary>
      </React.StrictMode>
    </BrowserRouter>
  );

  // Enables "Add to Home Screen" / install prompts and offline app-shell
  // caching. Only takes effect in production builds — see the file for why.
  // onUpdate fires once a new build has been fetched and is waiting to take
  // over — without wiring it up, someone with the app already open (or
  // installed as a PWA) has no way to know a new version exists short of
  // manually closing every tab, so they'd silently sit on stale/broken code.
  serviceWorkerRegistration.register({
    onUpdate: registration => {
      window.dispatchEvent(new CustomEvent("virsa-sw-update", { detail: registration }));
    }
  });
}
